// extracted by mini-css-extract-plugin
export default {"mainFTUE":"MainFTUE_mainFTUE__aCNGm"};